import type { Meta, StoryObj } from "@storybook/react";

import type { NotificationSettingsSectionProps } from "@/ui/components/notificationSettings";
import { NotificationSettingsSection } from "@/ui/components/notificationSettings";
import { Box } from "@/ui/layout";

const StoryMeta: Meta<NotificationSettingsSectionProps> = {
  title: "Components/Profile/Edit Notification Settings Section",
  component: NotificationSettingsSection,
  argTypes: {
    onChange: { action: "Notification setting changed" },

    receiveEmails: { control: "boolean" },

    receivePush: { control: "boolean" },
    receiveSms: { control: "boolean" },
  },
  args: {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    receiveEmails: true,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    receivePush: false,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    receiveSms: true,
  },
  render: (props) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { onChange, receiveEmails, receivePush, receiveSms } = props;

    return (
      <Box width="100%">
        <NotificationSettingsSection
          onChange={onChange}
          receiveEmails={receiveEmails}
          receivePush={receivePush}
          receiveSms={receiveSms}
        />
      </Box>
    );
  },
};

type Story = StoryObj<NotificationSettingsSectionProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
